import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicPortal from "@/pages/PublicPortal";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewDossier from "@/pages/NewDossier";
import DossierDetail from "@/pages/DossierDetail";
import ATraiter from "@/pages/ATraiter";
import Visits from "@/pages/Visits";
import Budget from "@/pages/Budget";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        Chargement…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PublicPortal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/a-traiter" element={<ProtectedRoute><ATraiter /></ProtectedRoute>} />
            <Route path="/admin/visites" element={<ProtectedRoute><Visits /></ProtectedRoute>} />
            <Route path="/admin/budget" element={<ProtectedRoute><Budget /></ProtectedRoute>} />
            <Route path="/admin/nouveau" element={<ProtectedRoute><NewDossier /></ProtectedRoute>} />
            <Route path="/admin/dossier/:id" element={<ProtectedRoute><DossierDetail /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
